import { Span, SpanContext, Tracer } from 'opentracing'
import { CustomSpanContext } from './custom-span-context'
import { CustomTracer } from './custom-tracer'
import { TraceEvent } from './trace-event'

export class CustomSpan extends Span {
  private tags: { [key: string]: any }

  constructor(
    private operationName: string,
    private customTracer: CustomTracer,
    private spanContext: CustomSpanContext,
    private startTime: number,
  ) {
    super()
    this.tags = {}
    this.setTag('service-name', 'www')
    this._setOperationName(operationName)
  }

  protected _context(): SpanContext {
    return this.spanContext
  }

  protected _tracer(): Tracer {
    return this.customTracer
  }

  protected _setOperationName(operationName: string): void {
    this.setTag('name', operationName)
    this.operationName = operationName
  }

  protected _addTags(tags: { [key: string]: any }): void {
    const keys = Object.keys(tags)
    for (const key of keys) {
      this.tags[key] = tags[key]
    }
  }

  protected _finish(finishTime?: number): void {
    const endTime = finishTime ? finishTime : Date.now()
    this.customTracer.sendEvent(this.toSpanEvent(endTime))
  }

  private toSpanEvent(endTime: number): TraceEvent {
    const traceEvent = {} as TraceEvent
    traceEvent.operationName = this.operationName
    traceEvent.traceId = this.spanContext.toTraceId()
    traceEvent.spanId = this.spanContext.toSpanId()
    traceEvent.parentId = this.spanContext.toParentId()
    traceEvent.startTime = this.startTime
    traceEvent.endTime = endTime
    traceEvent.tags = {}
    for (const key of Object.keys(this.tags)) {
      const value = this.tags[key]
      traceEvent.tags[key] = value
    }

    return traceEvent
  }
}
